'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLayout = getLayout;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _upperFirst = require('lodash/upperFirst');

var _upperFirst2 = _interopRequireDefault(_upperFirst);

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = require.context('./', true, /\w+\/\w+\.(jsx|js)$/);

var exportObj = {};
context.keys().forEach(function (key) {
  Object.assign(exportObj, context(key));
});
/**
 * option = {layoutOption, layout, route}
 */
function getLayout(option, viewContent) {
  var CustomLayouts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (option.route && option.route.layout) {
    (0, _defaultsDeep2.default)(option.layoutOption, option.route.layoutOption, { route: option.route });
    option.layout = option.route.layout;
    delete option.route;
  }

  var layouts = Array.isArray(option.layout) ? option.layout : [option.layout];
  var layoutType = layouts[layouts.length - 1];
  var Layout = void 0;
  if (Object(layoutType) === layoutType) {
    Layout = layoutType;
  } else {
    Layout = CustomLayouts[layoutType] || exportObj[(0, _upperFirst2.default)(layoutType)] || exportObj['ConsoleLayout'];
  }

  var layoutProps = Layout.getLayoutProps(option.layoutOption, viewContent);
  viewContent = _react2.default.createElement(Layout, layoutProps);
  if (layouts.length > 1) {
    option.layout = layouts.slice(0, -1);
    return getLayout(option, viewContent, CustomLayouts);
  } else {
    return viewContent;
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.jsx
// module id = 50
// module chunks = 0